import type { Translation } from '../types.ts';
import type en from '../en/editor.ts';

export default {
    inline: {
        confirmSwitch: 'Je niet-opgeslagen wijzigingen verwerpen en van taal wisselen?',
        confirmDiscard: 'Je niet-opgeslagen wijzigingen verwerpen?',
        renderFailed: 'Weergeven mislukt: HTTP {status}',
        notStored: 'Opgeslagen, maar {n} veld is niet bewaard. | Opgeslagen, maar {n} velden zijn niet bewaard.',
        defaultLanguage: 'Standaardtaal',
        editLocale: '{locale} bewerken',
    },
    fields: {
        title: 'Velden op deze pagina',
        editingLocale: 'Je bewerkt {locale}: onaangeroerde velden tonen {fallback}',
        scrollTo: 'Naar dit veld scrollen',
        edit: 'Dit veld bewerken',
        filled: 'Ingevuld',
        empty: 'Leeg',
        inherited: 'overgenomen',
        inheritedTitle: 'Niet vertaald: toont {fallback}. Bewerk het om te vertalen.',
    },
    toolbar: {
        ariaLabel: 'Editor',
        settings: 'Instellingen',
        form: 'formulier: {id}',
    },
    placeholder: {
        image: 'Klik op ⚙ om een afbeelding te kiezen',
        gallery: 'Klik op ⚙ om galerij-items toe te voegen',
        slideshow: "Klik op ⚙ om dia's toe te voegen",
        embed: 'Klik op ⚙ om de embed in te stellen',
    },
} satisfies Translation<typeof en>;
